import Timeline from '../../chart/timeline';
import BaselineChart from '../../baselines/chart';
import TodayMarker from '../../chart/todayMarker';

export default instance => {
  instance.attachEvent('onBeforeGanttRender', () => {
    Timeline.updateTimeScaleRange();
    BaselineChart.onBeforeGanttRender();
  });
  instance.attachEvent('onBeforeGanttRender', () => setTimeout(() => {
    TodayMarker.onBeforeGanttRender();
  }));
};
